import React, { useEffect, useState } from "react";
import { FaUsers, FaBoxes, FaHistory, FaSpinner } from "react-icons/fa";
import axios from "../Axios/Axios";
import { Line } from "react-chartjs-2";

import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement,Title, Tooltip, Legend,} from "chart.js";

ChartJS.register( CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

export default function Home() {
  const [customersCount, setCustomersCount] = useState(0);
  const [materialsCount, setMaterialsCount] = useState(0);
  const [ordersCount, setOrdersCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        setLoading(true);

        const mughalsLoggedIn = localStorage.getItem("mughalsLoggedIn");
        if (!mughalsLoggedIn) {
          console.warn("Token not found in localStorage!");
          setLoading(false);
          return;
        }

        const headers = { Authorization: `Bearer ${mughalsLoggedIn}` };

        // Customers Count
        const resCustomers = await axios.get("/api/customers", { headers });
        const customersData = Array.isArray(resCustomers.data)
          ? resCustomers.data
          : resCustomers.data.customers || resCustomers.data.data || [];
        setCustomersCount(customersData.length);

        // Materials Count
        const resMaterials = await axios.get("/api/materials/all", { headers });
        const materialsData = Array.isArray(resMaterials.data)
          ? resMaterials.data
          : resMaterials.data.materials || resMaterials.data.data || [];
        setMaterialsCount(materialsData.length);

        // Orders Count
        const resOrders = await axios.get("/api/assignmaterial/all", {
          headers,
        });
        const ordersData = Array.isArray(resOrders.data)
          ? resOrders.data
          : resOrders.data.orders || resOrders.data.data || [];
        setOrdersCount(ordersData.length);

        // Chart data
        const labels = ["Customers", "Materials", "Orders"];
        const counts = [
          customersData.length,
          materialsData.length,
          ordersData.length,
        ];

        setChartData({
          labels,
          datasets: [
            {
              label: "Total Records",
              data: counts,
              borderColor: "#6fb104",
              backgroundColor: "rgba(111, 177, 4, 0.3)",
              tension: 0.4,
              fill: true,
              pointRadius: 6,
              pointHoverRadius: 8,
              borderWidth: 3,
            },
          ],
        });
      } catch (err) {
        console.error("Error fetching dashboard data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        labels: { font: { size: 14 }, color: "#555" },
      },
      title: {
        display: true,
        text: "Dashboard Overview",
        font: { size: 22, weight: "bold" },
        color: "#333",
      },
    },
    scales: {
      y: { beginAtZero: true, ticks: { color: "#666" } },
      x: { ticks: { color: "#666" } },
    },
  };

  // Loading Spinner Component
  const LoadingIcon = () => (
    <FaSpinner className="spin" style={{ fontSize: 20, color: "#6fb104" }} />
  );

  return (
    <main className="dashboard-container">
      <header>
        <h1
          className="dashboard-heading text-start"
          style={{ color: "#6fb104" }}
        >
          Dashboard Overview
        </h1>
      </header>

      <section className="card-grid">
        <article className="info-card">
          <div className="icon-circle purple">
            <FaUsers />
          </div>
          <div className="info-content">
            <h3>Customers</h3>
            <p>{loading ? <LoadingIcon /> : customersCount}</p>
          </div>
        </article>

        <article className="info-card">
          <div className="icon-circle red">
            <FaBoxes />
          </div>
          <div className="info-content">
            <h3>Materials</h3>
            <p>{loading ? <LoadingIcon /> : materialsCount}</p>
          </div>
        </article>

        <article className="info-card">
          <div className="icon-circle orange">
            <FaHistory />
          </div>
          <div className="info-content">
            <h3>Orders</h3>
            <p>{loading ? <LoadingIcon /> : ordersCount}</p>
          </div>
        </article>
      </section>

      <section
        className="chart-section"
        style={{
          height: 400,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {loading ? (
          <FaSpinner
            className="spin"
            style={{ fontSize: 40, color: "#6fb104" }}
          />
        ) : (
          chartData && <Line data={chartData} options={chartOptions} />
        )}
      </section>

    </main>
  );
}
